import React from "react";

import logo from "../img/dvi-logo.png";

const Logo = (props) =>{
	  return <img src={logo} alt="Logo" style={{width: props.size, height: props.size}}/>;

	
} 
export default Logo